const TOOLTIP_WIDTH = 260;
const GAP = 8;

/**
 * Inline style for the "+N more categories" tooltip.
 *
 * The tooltip is fixed rather than absolute so it floats above the page instead
 * of living inside the table cell — an absolutely positioned tooltip is still
 * laid out within the table's scroll container, so long category names widened
 * the cell and added a horizontal scrollbar.
 *
 * This is the first-paint placement only; positionCategoryTooltip() refines it
 * once the real size is known.
 */
export function categoryTooltipStyle(rect) {
    const base = "position: fixed; z-index: 1000; background: var(--lighter); border: 1px solid var(--border);"
        + " border-radius: 6px; padding: 0.5rem 0.75rem; min-width: 140px; max-width: " + TOOLTIP_WIDTH + "px;"
        + " max-height: 50vh; overflow-y: auto; box-shadow: 0 4px 12px rgba(0,0,0,0.12); font-size: 0.82rem;"
        + " white-space: normal; color: var(--dark);";

    if (!rect) return base;
    return base + " left: " + Math.round(rect.right + GAP) + "px; top: " + Math.round(rect.top - 6) + "px;";
}

/**
 * Places the tooltip on whichever side of its anchor has room, then clamps it
 * into the viewport. Called from oncreate/onupdate, so the tooltip's real
 * rendered size is known — which is what lets the side be chosen automatically
 * instead of always opening right and hoping it fits.
 *
 * `el` is the tooltip element, `anchorRect` the icon's rect from mouseenter.
 */
export function positionCategoryTooltip(el, anchorRect) {
    if (!el || !anchorRect) return;

    const box = el.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    const spaceRight = vw - anchorRect.right - GAP;
    const spaceLeft = anchorRect.left - GAP;

    let left;
    if (box.width <= spaceRight) {
        left = anchorRect.right + GAP;              // preferred side
    } else if (box.width <= spaceLeft) {
        left = anchorRect.left - box.width - GAP;   // flip
    } else {
        left = spaceRight >= spaceLeft              // neither fits: use the roomier side
            ? Math.max(GAP, vw - box.width - GAP)
            : GAP;
    }

    // Centre on the anchor vertically, then keep it fully on screen.
    let top = anchorRect.top + (anchorRect.height / 2) - (box.height / 2);
    top = Math.max(GAP, Math.min(top, vh - box.height - GAP));

    el.style.left = Math.round(left) + "px";
    el.style.top = Math.round(top) + "px";
}

export default { categoryTooltipStyle, positionCategoryTooltip };
